
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programa-afiliados",
      function () {
        return require("private-next-pages/programa-afiliados/index.tsx");
      }
    ]);
  